/**
 * @author lifei
 * @description 封装处理 url 相关逻辑
 */

import { isObject } from 'lodash-es'
import { Base } from '../base'

export class Url extends Base {
  constructor() {
    super()
  }

  static {
    Base.register(this)
  }

  /**
   * 功能：将 query 分割成 json 对象
   * 参数：query<string>
   * 返回值：object
   */
  private split(query: string): TCommon.Json<string> {
    const ret: TCommon.Json = {}
    const pairs = query.split('&')
    pairs.forEach((el) => {
      const [key, val] = el.split('=')
      ret[key] = val
    })
    return ret
  }

  /**
   * 功能：将 json 对象 序列化
   * 参数：data<object>
   * 返回值：string
   */
  private join(data: TCommon.Json): string {
    const ret: string[] = []
    for (let key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        ret.push(`${key}=${data[key]}`)
      }
    }
    return ret.join('&')
  }

  /**
   * 功能：获取 url 参数
   * 参数：
   *  1. url<string>: 地址
   *  2. mid<string>: 指定的参数 key
   */
  public getParams(url: string = '', mid: string): TCommon.OrNull<string> {
    url = this.decodeURIComponent(url)
    const [path, query] = url.split('?')

    if (!query) return null

    const regx = new RegExp('(^|&)' + mid + '=([^&]*)(&|$)')
    const r = query.match(regx)
    if (r != null) return this.decodeURIComponent(r[2])
    return null
  }

  /**
   * 功能：解码 URL
   */
  public decodeURIComponent = (str: string): string => window.decodeURIComponent(str)

  /**
   * 功能: 编码 url
   */
  public encodeURIComponent = (str: string): string => window.encodeURIComponent(str)

  /**
   * 功能：拼接 url search 问号之后的部分, 不考虑 search 参数后存在 ？的情况, 如果存在 encodeURIComponent 处理
   * 参数：
   *  1. url<string>: url 地址
   *  2. data<object>
   */
  public serialize(url: string = '', data: TCommon.Json): string {
    if (!isObject(data)) {
      throw new Error('Expecting the parameter to be a JSON object, but get a other type')
    }

    const [path, query] = url.split('?')

    if (query) {
      data = {
        ...this.split(query),
        ...data,
      }
    }
    const newQuery = this.join(data)
    return [path, newQuery].join('?').replace(/\?$/, '')
  }

  /**
   * 功能：serialize 别名函数
   */
  public parse(url: string, data: TCommon.Json) {
    return this.serialize(url, data)
  }
}

export const URL = new Url()
